<script setup>
import { ref, computed, watch } from 'vue';
import { useQuasar } from 'quasar';
const $q = useQuasar();
const isLargeScreen = computed(() => $q.screen.gt.xs);

const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
    darkMode.value = newVal;
})


useHead({
    title: 'Contact Us',
    meta: [
        { name: 'description', content: 'Contact Us' }
    ]
})
</script>


<template>
    <div class="row justify-center q-mt-lg q-mb-lg">
        <div class="col-12 text-center">
            <h3 :class="darkMode ? 'text-grey-5' : 'text-brand'">Contact Us</h3>
        </div>
    </div>

    <div class="row justify-center q-mt-lg q-mb-lg">
        <div :class="['col-12 col-md-4', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
            <div :class="darkMode ? 'bg-transparent' : 'bg-white'" class="q-pa-md q-mb-md"
                :style="{ height: isLargeScreen ? '400px' : 'auto' }">
                <div class="text-h3 text-center" :class="darkMode ? 'text-grey-5' : 'text-brand'">Our Office</div>
                <br>
                <div class="q-pt-none q-mt-auto text-center">
                    <p style="font-size: 20px;" :class="darkMode ? 'text-grey-5' : 'text-brand'">
                        2120 Calumet St. Suite 3 <br>
                        Clearwater, FL 33765<br>
                    </p>
                </div>
            </div>
        </div>
        <div :class="['col-12 col-md-4', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
            <div :class="darkMode ? 'bg-transparent' : 'bg-white'" class="q-pa-md q-mb-md"
                :style="{ height: isLargeScreen ? '400px' : 'auto' }">
                <div class="text-h3 text-center" :class="darkMode ? 'text-grey-5' : 'text-brand'">Hours of Operation
                </div>
                <br>
                <div class="q-pt-none q-mt-auto text-center">
                    <p style="font-size: 20px;" :class="darkMode ? 'text-grey-5' : 'text-brand'">
                        8:30AM - 5PM EST, Mon to Fri
                    </p>
                </div>
            </div>
        </div>

        <div :class="['col-12 col-md-4', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
            <div :class="darkMode ? 'bg-transparent' : 'bg-white'" class="q-pa-md q-mb-md"
                :style="{ height: isLargeScreen ? '400px' : 'auto' }">
                <div class="text-h3 text-center" :class="darkMode ? 'text-grey-5' : 'text-brand'">Contact</div>
                <br>
                <div class="q-pt-none q-mt-auto text-center">
                    <p style="font-size: 20px;" :class="darkMode ? 'text-grey-5' : 'text-brand'">
                        information@onsightoptical.com <br>
                        (727) 461-4657
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>